import { onAuthStateChanged } from '@bear-auth/core';

import { interceptorNames } from '@/modules/api/constants';
import {
    applyRequestInterceptor,
    applyResponseInterceptor,
    removeRequestInterceptor,
    removeResponseInterceptor,
} from '@/modules/api/utils/interceptors';
import { backendVersionInterceptor } from '@/modules/backend-version/utils';
import { totalCountInterceptor } from '@/modules/secrets/utilities/interceptors';

import {
    authInterceptor,
    demoUserInterceptor,
    iapRedirectInterceptor,
    unauthorizedInterceptor,
    userAccessNotAllowedInterceptor,
    versionInterceptor,
} from '../../interceptors';
import type { AuthUser } from '../../schemas/oauth';

import './config';

import { env } from '@/env';
import { getStore } from '@/services/context';

import { authSessionEnd, authSessionStart } from '../actions';
import { setSession } from '../slices/auth';
import { bearAuthId, demoBearAuthId } from './create';

export function registerOnAuthStateChanged() {
    return onAuthStateChanged<AuthUser>(env.VITE_DEMO ? demoBearAuthId : bearAuthId, async session => {
        const { dispatch } = await getStore();

        dispatch(setSession(session));

        applyResponseInterceptor(interceptorNames.userAccessNotAllowed, undefined, userAccessNotAllowedInterceptor);

        switch (session.status) {
            case 'authenticated': {
                applyRequestInterceptor(interceptorNames.auth, undefined, authInterceptor);
                applyRequestInterceptor(interceptorNames.version, undefined, versionInterceptor);

                if (env.VITE_DEMO) {
                    applyRequestInterceptor(interceptorNames.demo, undefined, demoUserInterceptor);
                }

                applyResponseInterceptor(interceptorNames.unauthorized, undefined, unauthorizedInterceptor);
                applyResponseInterceptor(interceptorNames.backendVersion, backendVersionInterceptor);
                applyResponseInterceptor(interceptorNames.iapRedirect, iapRedirectInterceptor);
                applyResponseInterceptor(interceptorNames.totalCount, totalCountInterceptor);

                dispatch(authSessionStart());

                break;
            }

            case 'unauthenticated': {
                dispatch(authSessionEnd());

                removeRequestInterceptor(interceptorNames.auth);
                removeRequestInterceptor(interceptorNames.demo);
                removeRequestInterceptor(interceptorNames.version);

                if (env.VITE_DEMO) {
                    removeResponseInterceptor(interceptorNames.demo);
                }

                removeResponseInterceptor(interceptorNames.backendVersion);
                removeResponseInterceptor(interceptorNames.iapRedirect);
                removeResponseInterceptor(interceptorNames.totalCount);
                removeResponseInterceptor(interceptorNames.unauthorized);

                break;
            }
        }
    });
}
